
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/csr/industry/small-businesses",
      function () {
        return require("private-next-pages/csr/industry/small-businesses.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/csr/industry/small-businesses"])
      });
    }
  